import type { FC } from "react";

import type { Language } from "@ui/components/LanguageSelector";
import { setLanguageCookie } from "@ui/components/LanguageSelector";

import { UiCheckIcon } from "@jti/brand-icons/ui-check";

import { HeaderNavListItem } from "../HeaderNavListItem";

import styles from "./LanguagePanel.module.scss";

type LanguagePanelProps = {
  languages: Language[];
};

/**
 * Language sub-panel. The current language is marked with `aria-current` and a
 * checkmark. Selecting a language persists the choice via cookie before navigating.
 */
export const LanguagePanel: FC<LanguagePanelProps> = ({ languages }) => (
  <ul className={styles.list}>
    {languages.map(({ path, current, languageDisplayName, associatedCookieValue }) => (
      <li key={path}>
        <HeaderNavListItem
          label={languageDisplayName}
          aria-current={current ? "true" : undefined}
          variant="link"
          href={path}
          endIcon={current ? UiCheckIcon : undefined}
          aria-haspopup="true"
          onClick={() => setLanguageCookie(associatedCookieValue)}
        />
      </li>
    ))}
  </ul>
);
